<template lang="pug">
  .address-select-list
    fieldset
      .row.address-wrap(v-for="address in addresses" :key="address.id")
        .choice.xs-12
          MrRadio(v-model="selectedAddressId" :value="address.id" name="address")
            Address(:address="address")


</template>

<script>
  import { mapState } from 'vuex';
  import Address from "./Address";
  import MrRadio from "../mrRadio";

  export default {
    name: "AddressSelectList",
    components: {
      MrRadio,
      Address
    },

    computed: {
      ...mapState('addressBook', [
        'addresses'
      ]),

      selectedAddressId: {
        get() {
          return this.$store.state.addressBook.selectedAddressId;
        },

        set(val) {
          this.$store.commit('addressBook/setSelectedAddressId', val);
        }
      }
    }
   }
</script>

<style scoped lang="stylus">
  .address-wrap
    padding-bottom 1.5em

  .address
    display inline-block
    padding-left 0.5em
    vertical-align top

</style>